var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5V19C0 21.7614 2.23858 24 5 24H19C21.7614 24 24 21.7614 24 19V5C24 2.23858 21.7614 0 19 0H5ZM8.61118 6.73982L8.52971 6.66788C8.19043 6.40407 7.69985 6.42805 7.38808 6.73982C7.05033 7.07758 7.05033 7.62518 7.38808 7.96293L11.1002 11.6757L7.38808 15.3885L7.31613 15.4699C7.05233 15.8092 7.07631 16.2998 7.38808 16.6116C7.72583 16.9493 8.27343 16.9493 8.61118 16.6116L12.324 12.8995L16.0367 16.6116L16.1182 16.6835C16.4575 16.9473 16.9481 16.9233 17.2598 16.6116C17.5976 16.2738 17.5976 15.7262 17.2598 15.3885L13.5477 11.6757L17.2598 7.96293L17.3318 7.88145C17.5956 7.54217 17.5716 7.05159 17.2598 6.73982C16.9221 6.40207 16.3745 6.40207 16.0367 6.73982L12.324 10.4519L8.61118 6.73982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.16cb3f3857fc24e866c99238b88adc4d.svg";
export { ForwardRef as ReactComponent };